import { AppNavLink } from '@/components/ui/AppLink';
import { Button } from '@/components/ui/Button';
import { useT } from '@/lib/i18n';
import { AccountLink } from './AccountLink';
import { DownloadLink } from './DownloadLink';
import { JumpLinks } from './JumpLinks';
import { MobileMenu } from './MobileMenu';
import { ThemeToggle } from './ThemeToggle';
import { useHeaderVisibility } from './useHeaderVisibility';
import { Wordmark } from './Wordmark';

/**
 * Site header (banner landmark) — a fixed 72 px bar (64 px on a phone), sticky, solid page colour (D-370).
 *
 *   left    the SBG INDIA logo
 *   centre  the pages as plain links with a bar under the current one (≥ 1120 px)
 *   right   **Shop button — always visible, incl. the mobile bar** · Catalogue download icon (≥ sm, D-385) · Account (≥ sm) · Theme (≥ sm) · hamburger (< 1120 px)
 *
 * The bar never changes size or hides; past the top it only gains a faint shadow (`useHeaderVisibility`). There is no
 * site search in the header (D-350): finding a stone is the Shop page's own search box. Below 600 px Account/Theme live
 * in the mobile menu so the bar only carries what must never be hidden: the brand, Shop and the menu button.
 */
export function Header() {
  const t = useT();
  const { scrolled } = useHeaderVisibility();

  return (
    <header className="site-header" data-scrolled={scrolled}>
      <div className="site-header__inner">
        <div className="site-header__brand">
          <Wordmark />
        </div>

        <JumpLinks />

        <div className="site-header__actions">
          <Button asChild variant="primary" className="site-header__shop">
            <AppNavLink to="/shop">{t('nav.shop')}</AppNavLink>
          </Button>

          <DownloadLink className="hidden sm:inline-flex" />
          <AccountLink className="hidden sm:inline-flex" />
          <ThemeToggle className="hidden sm:inline-flex" />

          <MobileMenu />
        </div>
      </div>
    </header>
  );
}
